'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _CamRewind = require('./CamRewind');

var _CamRewind2 = _interopRequireDefault(_CamRewind);

var _withWindow = require('../helpers/withWindow');

var _withWindow2 = _interopRequireDefault(_withWindow);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _withWindow2.default)(_CamRewind2.default);


//////////////////
// WEBPACK FOOTER
// ./~/@surfline/quiver-react/dist/CamRewind/index.js
// module id = 117
// module chunks = 11